import React, { useEffect, useState } from "react";

import arrowleft from "../assets/images/arrow-left.png";

import { Link, useParams, useNavigate } from "react-router-dom";
import Nav from "./Nav";
import http from "../services/http";
import moment from "moment";
import DropdownRight from "./DropdownRight";
import GetStorage from "../services/Storage";
import polygon from "../assets/images/Polygon 56.png";

export default function Details() {
  const token = GetStorage.get("xAuthToken");

  const params = useParams();
  const navigate = useNavigate();
  const [detail, setDetail] = useState({});
  useEffect(() => {
    Details();
  }, []);

  const Details = async () => {
    http
      .get(`api/admin/order/show/${params.id}?token=${token}`)
      .then((res) => {
        console.log("response details===>", res.data);

        setDetail(res.data);
      })
      .catch((error) => {
        console.log("error in order---->", error);
      });
  };
  return (
    <>
      <body>
        <div className="wrapper">
          <Nav />

          <div id="content">
            <header>
              <div className="dashboard_header">
                <div className="left-side d-flex ">
                  {" "}
                  <button
                    onClick={() => navigate("/evoOrders")}
                    type="button"
                    id="sidebarCollapse"
                    className="btn btn-link  "
                  >
                    {" "}
                    <img src={arrowleft} className="img-fluid" />{" "}
                  </button>
                  <h1>Details</h1>
                </div>

                <DropdownRight />
              </div>
            </header>
            <div class="dashbord_content">
              <div class="vedio_img">
                {detail ? (
                  <>
                    <Link
                      to="/video"
                      state={{
                        name: detail.firstCameraoutput,
                        id:detail.recording_id
                      }}
                    >
                      <video
                        width={100}
                        height={70}
                        src={detail.firstCameraoutput}
                      />
                      <img
                        src={polygon}
                        alt=""
                        style={{
                          position: "absolute",
                          marginTop: 25,
                          marginLeft: -60,
                          width: 20,
                          height: 20,
                        }}
                      />
                    </Link>

                    <p style={{ marginLeft: 10 }}>
                      {detail.firstCameraoutput &&
                        detail?.firstCameraoutput
                          .split("/")
                          [
                            detail.firstCameraoutput.split("/").length - 1
                          ].toUpperCase()}
                    </p>
                  </>
                ) : (
                  ""
                )}
              </div>
              <div class="row team_card">
                <div class="col-lg-6">
                  <div class="card">
                    <div class="head">
                      <h5>Order Details</h5>
                    </div>
                    <div class="card-inner">
                      <div class="row">
                        <div class="col-5">
                          <h5>Analyst Name</h5>
                          <h5>Package</h5>
                          <h5>Price</h5>
                          <h5>Date Placed</h5>
                          <h5>Status</h5>
                          <h5>Payment Status</h5>
                          <h5>Video Clip</h5>
                        </div>
                        <div class="col-7">
                          <p>
                            {detail?.analystFirstname} {detail?.analystLastname}
                          </p>
                          <p style={{ fontFamily: "unset" }}>
                            {detail?.package}
                          </p>
                          <p>{detail?.price}</p>
                          <p>
                            {" "}
                            {moment(detail?.created_at).format("MMM Do YY")}
                          </p>
                          <p class="text_green">{detail?.status}</p>
                          <p> file.csv</p>
                          <p>
                            {detail.evo_path &&
                              detail?.evo_path
                                .split("/")
                                [
                                  detail.evo_path.split("/").length - 1
                                ].toUpperCase()}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="card h_auto">
                    <div class="head">
                      <h5>Banking Info</h5>
                    </div>
                    <div class="card-inner">
                      <div class="row">
                        <div class="col-5">
                          <h5>Parent Name</h5>
                          <h5>Full Name</h5>
                          <h5>Team</h5>
                          <h5>Group</h5>
                          <h5>Gender</h5>
                          <h5>Age</h5>
                          <h5>Birthdate</h5>
                        </div>
                        <div class="col-7">
                          <p> {detail.parentFirstname}</p>
                          <p>
                            {" "}
                            {detail.parentFirstname} {detail.parentLastname}
                          </p>
                          <p>{detail.teamName}</p>
                          <p>{detail.groupName}</p>
                          <p>
                            {" "}
                            {detail.gender === "FEMALE" ? "Female" : "Male"}
                          </p>
                          <p>{detail.age}</p>
                          <p>
                            {" "}
                            {moment(detail.birthday).format("Do MMM YYYY")}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </body>
    </>
  );
}
